import { render } from "./UserPerfilator.vue?vue&type=template&id=b4822636&scoped=true"
import script from "./UserPerfilator.vue?vue&type=script&lang=js"
export * from "./UserPerfilator.vue?vue&type=script&lang=js"

import "./UserPerfilator.vue?vue&type=style&index=0&id=b4822636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4822636"]])

export default __exports__